import { render, staticRenderFns } from "./ProspectCustomersList.vue?vue&type=template&id=2837f98f"
import script from "./ProspectCustomersList.vue?vue&type=script&lang=js"
export * from "./ProspectCustomersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports